import { render, staticRenderFns } from "./ApexChartNewTechnologiesData.vue?vue&type=template&id=0651578f&"
import script from "./ApexChartNewTechnologiesData.vue?vue&type=script&lang=js&"
export * from "./ApexChartNewTechnologiesData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports